import type { EntityScope, Language, RankingBand, TemplateType } from "@/api/copyTemplates.service";

export const TEMPLATE_TYPES: { value: TemplateType; label: string }[] = [
  { value: "newsletter", label: "Newsletter" },
  { value: "website", label: "Website" },
  { value: "intranet", label: "Intranet" },
  { value: "press_release", label: "Press release" },
  { value: "email", label: "Email" },
  { value: "social_1", label: "Social one" },
  { value: "social_2", label: "Social two" },
  { value: "social_3", label: "Social three" },
];

export const LANGUAGES: { value: Language; label: string }[] = [
  { value: "en", label: "English" },
  { value: "de", label: "German" },
  { value: "fr", label: "French" },
];

export const ENTITY_SCOPES: { value: EntityScope; label: string }[] = [
  { value: "firm", label: "Firms" },
  { value: "set", label: "Chambers / sets" },
];

export const RANKING_BANDS: { value: RankingBand; label: string }[] = [
  { value: "any", label: "Every band" },
  { value: "top_tier", label: "Top tier firm" },
  { value: "recommended_firm", label: "Recommended firm" },
  { value: "firm_to_watch", label: "Firm to watch" },
  { value: "accolade", label: "Client satisfaction accolade" },
  { value: "recommended_lawyer", label: "Recommended lawyer" },
];

export function templateTypeLabel(type: TemplateType): string {
  return TEMPLATE_TYPES.find(item => item.value === type)?.label ?? type;
}

export function languageLabel(language: Language): string {
  return LANGUAGES.find(item => item.value === language)?.label ?? language;
}

export function entityScopeLabel(scope: EntityScope): string {
  return ENTITY_SCOPES.find(item => item.value === scope)?.label ?? scope;
}

export function rankingBandLabel(band: RankingBand): string {
  return RANKING_BANDS.find(item => item.value === band)?.label ?? band;
}
